import React from 'react';
import Icon from '../../components/Icon';

// KPI-карточка верхнего ряда.
const StatCard = ({ title, value, delta, trend = 'up', caption, hint }) => (
  <div className="stats-card stats-kpi">
    <div className="stats-kpi-head">
      <span className="stats-kpi-title">{title}</span>
      <span className={`stats-badge stats-badge--${trend}`}>
        <Icon name={trend === 'up' ? 'trending-up' : 'trending-down'} size={12} />
        {delta}
      </span>
    </div>

    <div className="stats-kpi-value">{value}</div>

    <div className="stats-kpi-foot">
      <span className="stats-kpi-caption">
        {caption}
        <Icon name={trend === 'up' ? 'trending-up' : 'trending-down'} size={14} />
      </span>
      <span className="stats-kpi-hint">{hint}</span>
    </div>
  </div>
);

export default StatCard;
